import { Link } from '@ets/design-system';

type OriginalLocationCellProps = {
  object: Objekt;
};

const OriginalLocationCell = ({ object }: OriginalLocationCellProps) => {
  return object.parent ? (
    <div>
      <Link
        size="s"
        variant="primary"
        href={`/storage/${object.parent.type}/${object.parent.id}`}
        testId="original-location"
      >
        {object.parent.name}
      </Link>
    </div>
  ) : null;
};

export default OriginalLocationCell;
